/**
 * @module builder
 */
import type { Contact } from '@paintscout/api'
import isNumber from 'lodash/isNumber'
import type { QuoteDocument } from 'paintscout'
import { getQuoteLoanApplication } from '../get-quote-loan-application'

export const setContact = (args: {
  quote: QuoteDocument
  contact: Partial<Contact>
  currentDealId?: number | string
}): QuoteDocument => {
  const { quote, contact, currentDealId } = args
  const { _id, _rev, ...contactInfo } = contact
  // this is a bit hackey currently - we should actually be passing the provider to here
  const source = currentDealId
    ? isNumber(currentDealId)
      ? { ...(quote?.source ?? {}), dealId: currentDealId }
      : { ...(quote?.source ?? {}), provider: 'salesforce', id: currentDealId }
    : quote?.source

  const loanApplication = getQuoteLoanApplication({ contact, quote })

  if ((contactInfo as any).wisetackLoanApplication) {
    delete (contactInfo as any).wisetackLoanApplication
  }
  return {
    ...quote,
    source,
    contact: {
      ...contactInfo,
      id: _id,
      rev: _rev,
      wisetackLoanApplication: loanApplication
    }
  }
}
